import formUtil from '_common/formSource/common/formUtil';
import { translate } from '_common/utils/language';

import getBase1 from './P_BASE';

function P2_GUARDIAN() {
  const base = getBase1();
  const template = [
    {
      title: translate('jp.verification.guardian.form.title1'),
      form: {
        firstNameTotal0: formUtil.addMultiInpuKeyIndex(base, 'firstName', 0),
        firstNamePyTotal0: formUtil.addMultiInpuKeyIndex(
          base,
          'firstNamePy',
          0
        ),
        sex0: base.sex,
        birthday0: base.birthDay,
        countryCode0: base.countryCode,
        residence0: base.residenceCodeForGuardian,
        postCode0: base.postCode,
        addressData0: formUtil.addMultiInpuKeyIndex(base, 'addressData', 0),
        street0: base.street,
        location0: base.location,
        career0: formUtil.addMultiInpuKeyIndex(base, 'career', 0),
        position0: base.position,
        income0: base.income,
        financialAssets0: base.financialAssets,
      },
    },
    {
      title: translate('jp.verification.guardian.form.title2'),
      form: {
        firstNameTotal1: formUtil.addMultiInpuKeyIndex(base, 'firstName', 1),
        firstNamePyTotal1: formUtil.addMultiInpuKeyIndex(
          base,
          'firstNamePy',
          1
        ),
        sex1: base.sex,
        birthday1: base.birthDay,
        countryCode1: base.countryCode,
        residence1: base.residenceCodeForGuardian,
        postCode1: formUtil.addMultiInpuKeyIndex(base, 'postCode', 1),
        addressData1: formUtil.addMultiInpuKeyIndex(base, 'addressData', 1),
        street1: base.street,
        location1: base.location,
        career1: formUtil.addMultiInpuKeyIndex(base, 'career', 1),
        position1: base.position,
        income1: base.income,
        financialAssets1: base.financialAssets,
      },
    },
  ];
  return template;
}

export default P2_GUARDIAN;
